<template>
  <div>
    <slot name="tagline" :product-availability="productAvailability" />
    <slot :product-availability="productAvailability" />
  </div>
</template>

<script>
export default {
  data () {
    return {
      productAvailability: {
        hasResorts: false,
        hasLiveaboards: false,
        hasYachts: false,
        hasEcoventures: false
      }
    }
  },
  mounted () {
    if (window.zubluDestination) {
      const url = `${window.ZUBLU_VARIABLES.ODYSSEY_API}/api/v2/products_availability_query`
      const payload = {
        destination_structure: window.zubluDestination
      }

      $.post(url, payload)
        .then(response => {
          this.productAvailability = response
        })
    }
  }
}
</script>